/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  SupportRequestDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    SupportRequestDtoFromJSON,
    SupportRequestDtoToJSON,
} from '../models/index';

export interface DeRegisterQaEquipmentRequest {
    id: string;
}

export interface RegisterQaEquipmentRequest {
    id: string;
}

export interface RequestCalibrationDataSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

export interface RequestSerialNumberAssignmentSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

export interface RequestSupportForDeviceRequest {
    id: string;
    supportRequestDto?: SupportRequestDto;
}

/**
 * 
 */
export class QaEquipmentCloudApi extends runtime.BaseAPI {

    /**
     */
    async deRegisterQaEquipmentRaw(requestParameters: DeRegisterQaEquipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deRegisterQaEquipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}/deregister`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deRegisterQaEquipment(requestParameters: DeRegisterQaEquipmentRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deRegisterQaEquipmentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async registerQaEquipmentRaw(requestParameters: RegisterQaEquipmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling registerQaEquipment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/qa-equipment/{id}/register`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async registerQaEquipment(requestParameters: RegisterQaEquipmentRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.registerQaEquipmentRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async requestCalibrationDataSupportForDeviceRaw(requestParameters: RequestCalibrationDataSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling requestCalibrationDataSupportForDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment/{id}/calibration-support-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters.supportRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async requestCalibrationDataSupportForDevice(requestParameters: RequestCalibrationDataSupportForDeviceRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.requestCalibrationDataSupportForDeviceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async requestSerialNumberAssignmentSupportForDeviceRaw(requestParameters: RequestSerialNumberAssignmentSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling requestSerialNumberAssignmentSupportForDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment/{id}/sn-assignment-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters.supportRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async requestSerialNumberAssignmentSupportForDevice(requestParameters: RequestSerialNumberAssignmentSupportForDeviceRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.requestSerialNumberAssignmentSupportForDeviceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async requestSupportForDeviceRaw(requestParameters: RequestSupportForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling requestSupportForDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/qa-equipment/{id}/support-request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRequestDtoToJSON(requestParameters.supportRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async requestSupportForDevice(requestParameters: RequestSupportForDeviceRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.requestSupportForDeviceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
